import { SvgIcon } from "@progress/kendo-react-common";
import { sortAscSmallIcon } from "@progress/kendo-svg-icons";
import { FunctionComponent } from "react";
import { Zone } from "../api";
import classes from "./StreetBlockInventory.module.scss";
import { VerticalLabel } from "./VerticalLabel";
import { ZoneInventory } from "./ZoneInventory";

export const StreetBlockInventory: FunctionComponent<{
  className?: string;
  zones: Zone[];
  pageBreak?: boolean;
}> = ({ className, zones, pageBreak }) => {
  return zones.length > 0 ? (
    <div className={`${classes.content} ${className}`}>
      <div
        className={`${classes.header} ${classes.h1} ${
          pageBreak ? "page-break" : ""
        }`}
      >
        {zones[0].CrossStreetStartName}
      </div>
      <div className={classes.body}>
        <VerticalLabel className={classes["vertical-header"]}>
          <SvgIcon
            svgClassName="k-rotate-270"
            size="large"
            icon={sortAscSmallIcon}
          />
          <span className={classes.h1}>{zones[0].StreetName}</span>
          <SvgIcon
            svgClassName="k-rotate-270"
            size="large"
            icon={sortAscSmallIcon}
          />
        </VerticalLabel>
        <div className={classes.inventory}>
          {zones.map((x, i) => (
            <ZoneInventory key={i} className="avoid-page-break" zone={x} />
          ))}
        </div>
      </div>
      <div className={`${classes.footer} ${classes.h1}`}>
        {zones[0].CrossStreetEndName}
      </div>
    </div>
  ) : (
    <></>
  );
};
